"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var button_component_1 = __importStar(require("../inputs/button.component"));
var react_dom_1 = require("react-dom");
var CloseOutline_1 = __importDefault(require("../icons/generated/CloseOutline"));
var modal_style_component_1 = require("./modal.style.component");
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
var Modal = function (_a) {
    var title = _a.title, icon = _a.icon, close = _a.close, children = _a.children, ok = _a.ok, show = _a.show, showFooter = _a.showFooter, testID = _a.testID, _b = _a.small, small = _b === void 0 ? false : _b, _c = _a.wide, wide = _c === void 0 ? false : _c, _d = _a.medium, medium = _d === void 0 ? false : _d, _e = _a.mediumSizeTitle, mediumSizeTitle = _e === void 0 ? false : _e, _f = _a.fullScreenOnMobile, fullScreenOnMobile = _f === void 0 ? false : _f, _g = _a.boldTitle, boldTitle = _g === void 0 ? false : _g, okMessage = _a.okMessage, _h = _a.alarmOkButton, alarmOkButton = _h === void 0 ? false : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, layerLevel = _a.layerLevel;
    var getTranslation = use_translations_hook_1.default().getTranslation;
    var okMessageText = okMessage ? okMessage : getTranslation('GLOBAL:OK');
    return (react_1.default.createElement(modal_style_component_1.ModalDialog, { id: "modal-dialog", show: show, "data-test-id": testID, small: small, medium: medium, wide: wide, fullScreenOnMobile: fullScreenOnMobile, layerLevel: layerLevel },
        !small && (react_1.default.createElement(modal_style_component_1.ModalClose, { "data-test-id": "alert-details-close", className: "close-modal", onClick: close },
            react_1.default.createElement(CloseOutline_1.default, null))),
        react_1.default.createElement(modal_style_component_1.ModalTitle, { small: small, mediumSizeTitle: mediumSizeTitle, boldTitle: boldTitle },
            icon && react_1.default.createElement(modal_style_component_1.ModalIconWrapper, null, icon),
            title),
        react_1.default.createElement(modal_style_component_1.ModalBody, null, children),
        showFooter && (react_1.default.createElement(modal_style_component_1.ModalFooter, null,
            react_1.default.createElement(button_component_1.SecondaryButton, { className: "cancel-modal", onClick: close }, getTranslation('GLOBAL:CANCEL')),
            ok && !alarmOkButton && (react_1.default.createElement(button_component_1.default, { className: "ok-modal", onClick: ok }, okMessageText)),
            ok && alarmOkButton && (react_1.default.createElement(button_component_1.AlarmButton, { disabled: disabled, className: "ok-modal", onClick: ok }, okMessageText))))));
};
Modal.displayName = 'Modal';
var ModalContainer = function (props) {
    var modalRoot = document.getElementById('modal-root');
    var _a = react_1.useState(props.show), internalShow = _a[0], setInternalShow = _a[1];
    var show = props.show, close = props.close, layerLevel = props.layerLevel;
    react_1.useEffect(function () {
        if (!show && internalShow) {
            setTimeout(function () { return setInternalShow(false); }, 500);
        }
        else if (show)
            setInternalShow(true);
    }, [show, internalShow]);
    if (!modalRoot) {
        return null;
    }
    return react_dom_1.createPortal(react_1.default.createElement(react_1.default.Fragment, null, internalShow && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(modal_style_component_1.Overlay, { show: internalShow && show, onClick: close, layerLevel: layerLevel }),
        react_1.default.createElement(Modal, __assign({}, props, { show: internalShow && show }))))), modalRoot);
};
ModalContainer.displayName = 'ModalContainer';
exports.default = ModalContainer;
//# sourceMappingURL=modal.component.js.map